import { useAppDispatch } from "../../redux/hooks";
import { useEffect, useRef } from "react";
import { SmarticoEvents } from "../../redux/features/raffle/interfaces/SmarticoEvents";
import useSmartico from "../../hooks/useSmartico";
import { SmarticoRaffleDrawIds } from "../../redux/features/raffle/interfaces/SmarticoRaffleDrawIds";
import { getCookie } from "../../../helpers/cookies";
import TombolaPageRender from "../../redux/features/raffle/renders/christmas-raffle/TombolaPageRender";
import "./draws.css";
import {
  getDrawRunHistory,
  getSmarticoRaffles,
  setDrawAdditionalData,
  useRaffleDrawsHistory,
  useRaffleDrawsHistoryLoading,
  useSmarticoRaffle,
} from "../../redux/features/raffle/store";
import { TombolaPage } from "../../redux/features/raffle/components";
import dayjs from "dayjs";

const RAFFLE_ID = "230";

const ChristmasRaffleContentPage = () => {
  const isAuth = getCookie("BotB.Authenticated") === "true";
  const dispatch = useAppDispatch();
  const raffle = useSmarticoRaffle();
  const historyDailyDraws = useRaffleDrawsHistory(SmarticoRaffleDrawIds.HOURLY_DRAW);
  const api = useSmartico();
  const shouldStop = useRef(false);
  const areRaffleDrawsLoading = useRaffleDrawsHistoryLoading();
  useEffect(() => {
    const onIdentify = () => {
      dispatch(getSmarticoRaffles(api));
    };
    window.addEventListener(SmarticoEvents.identify, onIdentify);
    return () => {
      window.removeEventListener(SmarticoEvents.identify, onIdentify);
    };
  }, []);

  useEffect(() => {
    if (raffle.draws.length > 0 && !shouldStop.current) {
      dispatch(
        getDrawRunHistory({
          api,
          draw_ids: [SmarticoRaffleDrawIds.HOURLY_DRAW],
        })
      );
      shouldStop.current = true;
    }
  }, [raffle.draws]);

  useEffect(() => {
    if (areRaffleDrawsLoading) {
      return;
    }
    const startDate = dayjs(raffle.start_date)
      .set("hours", 0)
      .set("minutes", 0)
      .set("seconds", 0)
      .set("milliseconds", 0);
    const endDate = dayjs(raffle.end_date)
      .set("hours", 23)
      .set("minutes", 59)
      .set("seconds", 59)
      .set("milliseconds", 59);
    const totalDays = Math.round(dayjs(endDate).diff(dayjs(startDate), "days", true));
    dispatch(
      setDrawAdditionalData({
        [SmarticoRaffleDrawIds.HOURLY_DRAW]: {
          badge: `Today's Draw \nDAY ${historyDailyDraws.length + 1}/${totalDays}`,
          // badge: `Today Draw \nDAY ${historyDailyDraws.length + 1}/${totalDays}`,
          requiredTickets: 1,
          description:
            "Every day at 6PM, 6,000 prizes drop, from £1,000 tax-free cash to competition tickets and game credit.",
          // description: "Every day at 9:30PM, 5,000 prizes drop, from £1,000 Cash to tickets & game credit.",
          title: "What will you win tonight?",
          image: "/assets/images/big-7-draws/card-halloween-daily.webp",
          // image: "/assets/images/big-7-draws/card-1.png",
          displayOrder: 1,
          prizesText: "£17,000+",
          // prizesText: "£10,000+",
          winnersLabel: "Daily Winners",
          winnersText: "6,000",
          // winnersText: "5,000",
          ticketsText: "Tickets in tonights draw:",
        },
        [SmarticoRaffleDrawIds.GRAND_DRAW]: {
          badge: "Grand Finale",
          requiredTickets: 10,
          description:
            "All tickets go into the big 31st October draw for a Toyota GR Yaris + 11,999 other prizes.",
          title: "Win a Toyota GR Yaris!",
          image: "/assets/images/big-7-draws/card-halloween-finale.webp",
          displayOrder: 2,
          prizesText: "£119,000+",
          winnersLabel: "Winners",
          winnersText: "12,000",
          ticketsText: "Tickets in the Grand Finale:",
        },
      })
    );
  }, [raffle.end_date, raffle.start_date, areRaffleDrawsLoading]);

  return <TombolaPage isAuth={isAuth} searchParamRaffleId={RAFFLE_ID} Render={TombolaPageRender} />;
};

export default ChristmasRaffleContentPage;
